import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {
  getDiamondImage, 
  getWatchThumbnailImage, 
  formatDiamondTitle, 
  formatMeasurements, 
  formatLocation, 
  formatCut, 
  formatCarat, 
  formatCost, 
  formatColor, 
  formatPrice, 
  formatClarity,
} from '../../../utils/formatting';

import * as storage from '../../../persistance/storage';
import * as api from '../../../constants/api';

import AddDiamondConfirm from '../../common/alert/AddDiamondConfirm';
import RhinoCheckbox from '../../common/inputs/RhinoCheckbox';

import * as commonActionCreators from '../../../actions/common';
import * as leadsActionCreators from '../../../actions/leads';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, leadsActionCreators, usersActionCreators);

class ShareDirect extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      serverError: null,
      sendingRequest: false,

      includeGia: false,
      includePrice: false,
      includeImage: false,
      includeVideo: false,
      message: '',

      externalShare: null,
      shareError: null,

      email: '', 
      emailSectionOpen: false,
    }

    this.authToken = storage.get('token');
	}

  componentDidUpdate(prevProps, prevState) {
    this.authToken = storage.get('token');
  }

  componentWillUnmount() {
    
  }

  closeDropdown() {

    this.setState({
      serverError: null,
      sendingRequest: false,

      includeGia: false,
      includePrice: false,
      includeImage: false,
      includeVideo: false,
      message: '',

      externalShare: null,
      shareError: null,

      email: '', 
      emailSectionOpen: false,
    })

    this.props.leadsCloseShareDirectDropdown();
  }

  getRootClass() {
    return this.props.leads.shareDirectDropdownOpen ? 'ShareDirect open' : 'ShareDirect';
  }

  handleSubmitWatch() {

    const watchSkus = [];
    for(const watchObj of this.props.leads.shareDirectDropdownDiamonds) {
      watchSkus.push(watchObj.sku);
    }

    const shareData = {
      watches: watchSkus,
      include_gia: false,
      include_price: true,
      include_image: true,
      include_video: false,
      message: this.state.message,
    }

    this.props.leadsCreateExternalWatch(shareData)
    .then((respData) => {
      this.setState({ 
        externalShare: respData.share,
      });
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    //   this.setState({
    //     shareError: errorResp.message,
    //   });
    // });
  }

  handleSubmit() {

    if(this.isWatch()) {
      this.handleSubmitWatch();
      return null;
    }

    const diamond_ids = [];
    for(const diaObj of this.props.leads.shareDirectDropdownDiamonds) {
      diamond_ids.push(diaObj.id);
    }

    const shareData = {
      diamonds: diamond_ids,
      include_gia: this.state.includeGia,
      include_price: this.state.includePrice,
      include_image: this.state.includeImage,
      include_video: this.state.includeVideo,
      message: this.state.message,
    }

    this.props.leadsCreateExternal(shareData)
    .then((respData) => {
      this.setState({ 
        externalShare: respData.share,
      });
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    //   this.setState({
    //     shareError: errorResp.message,
    //   });
    // });
  }

  getDropdownTitle() {
    return 'Share with Customer';
  }

  toggleIncludeGia() {
    this.setState({ includeGia: !this.state.includeGia });
  }

  toggleIncludePrice() {
    this.setState({ includePrice: !this.state.includePrice });
  }

  toggleIncludeImage() {
    this.setState({ includeImage: !this.state.includeImage });
  }

  toggleIncludeVideo() {
    this.setState({ includeVideo: !this.state.includeVideo });
  }

  changeMessage(evt) {
    this.setState({ message: evt.target.value })
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  sendShareWatchEmail() {

    const watchSkus = [];
    for(const watchObj of this.props.leads.shareDirectDropdownDiamonds) {
      watchSkus.push(watchObj.sku);
    }

    const shareData = {
      email: this.state.email,
      watches: watchSkus,
      include_gia: false,
      include_price: true,
      include_image: true,
      include_video: false,
      message: this.state.message,
    }

    this.props.leadsShareExternalWatch(shareData)
    .then((respData) => {
      this.props.commonAlert(watchSkus.length > 1 ? 'Timepieces shared successfully' : 'Timepiece shared successfully');
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    // });
    this.closeDropdown();
  }

  sendShareEmail() {

    if(this.isWatch()) {
      this.sendShareWatchEmail();
      return null;
    }

    const diamond_ids = [];
    for(const diaObj of this.props.leads.shareDirectDropdownDiamonds) {
      diamond_ids.push(diaObj.id);
    }

    const shareData = {
      email: this.state.email,
      diamonds: diamond_ids,
      include_gia: this.state.includeGia,
      include_price: this.state.includePrice,
      include_image: this.state.includeImage,
      include_video: this.state.includeVideo,
      message: this.state.message,
    }

    this.props.leadsShareExternal(shareData)
    .then((respData) => {
      this.props.commonAlert('Diamonds shared successfully');
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    // });
    this.closeDropdown();
  }

  showEmailSection() {
    this.setState({
      emailSectionOpen: true,
    })
  }

  isDiamond() {
    return this.props.leads.shareDirectDropdownType === 'DIAMOND';
  }

  isWatch() {
    return this.props.leads.shareDirectDropdownType === 'WATCH';
  }

	render() {

    let base_url = api.FRONTEND_URL;

		return <div className={this.getRootClass()}>
      <div className='innerWrapper'>
        <div className='closeIcon' onClick={this.closeDropdown.bind(this)}>&times;</div>
        <div className='newTitle'>{this.getDropdownTitle()}</div>
        {this.state.externalShare === null ?
          <div className='diamondStep'>
            {this.props.leads.shareDirectDropdownDiamonds ?
              <div>
                {this.props.leads.shareDirectDropdownDiamonds.map((diamond, i) => {
                  if(this.isWatch()) {
                    return <div className={'diamondWrapper watchWrapper'} key={i}>
                      <div className='diamondImageWrapper'>
                        <img src={getWatchThumbnailImage(diamond)} />
                      </div>
                      <div className='diamondBodyWrapper'>
                        <div className='diamondTitle'>{diamond.description}</div>
                        <div className='diamondMeasurementRow' style={{ display: 'none' }}>
                          <div className='diamondLocation'>
                            <div className='diamondLocationIcon'>
                              <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                          </div>
                        </div>
                        <div className='diamondInfoBlock'>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Price:</div>
                            <div className={'diamondInfoValue EllipsisElement'}>{formatPrice(diamond)}</div>
                          </div>
                          {diamond.movement ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Movement:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{diamond.movement}</div>
                            </div> :
                            null
                          }
                          {diamond.crystal ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Crystal Type:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{diamond.crystal}</div>
                            </div> :
                            null
                          }
                          {diamond.dial_color ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Dial Color:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{diamond.dial_color}</div>
                            </div> :
                            null
                          }
                          {diamond.case_material ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Case Material:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{diamond.case_material}</div>
                            </div> :
                            null
                          }
                          {parseFloat(diamond.case_size) ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Case Size:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{parseFloat(diamond.case_size) ? `${diamond.case_size} mm` : ''}</div>
                            </div> :
                            null
                          }
                          {diamond.band_material ?
                            <div className='diamondInfoItem'>
                              <div className='diamondInfoLabel'>Band Material:</div>
                              <div className={'diamondInfoValue EllipsisElement'}>{diamond.band_material}</div>
                            </div> :
                            null
                          }
                        </div>
                      </div>
                    </div>;
                  } else {
                    return <div className='diamondWrapper' key={i}>
                      <div className='diamondImageWrapper'>
                        <img src={getDiamondImage(diamond)} />
                      </div>
                      <div className='diamondBodyWrapper'>
                        <div className='diamondTitle'>{formatDiamondTitle(diamond)}</div>
                        <div className='diamondMeasurementRow'>
                          {diamond.measurements ? 
                            <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                            null
                          }
                          <div className='diamondLocation'>
                            <div className='diamondLocationIcon'>
                              <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                          </div>
                        </div>
                        <div className='diamondInfoBlock'>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Cut:</div>
                            <div className='diamondInfoValue'>{formatCut(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Lab:</div>
                            <div className='diamondInfoValue'>{diamond.lab}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Carat:</div>
                            <div className='diamondInfoValue'>{formatCarat(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem' style={{ display: 'none' }}>
                            <div className='diamondInfoLabel'>Cost:</div>
                            <div className='diamondInfoValue'>{formatCost(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Color:</div>
                            <div className='diamondInfoValue'>{formatColor(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Price:</div>
                            <div className='diamondInfoValue'>{formatPrice(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>Clarity:</div>
                            <div className='diamondInfoValue'>{formatClarity(diamond)}</div>
                          </div>
                          <div className='diamondInfoItem'>
                            <div className='diamondInfoLabel'>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                            <div className='diamondInfoValue'></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                })}
                {this.isDiamond() ?
                  <div className='inclusionFilterWrapper'>
                    <div className='includeTitle'>Additional Shared Information:</div>
                    <div className='includeItemWrapper'>
                      {this.isDiamond() ?
                        <div className='includeItem'>
                          <div className='includeCheckbox'>
                            <RhinoCheckbox
                              selected={this.state.includeGia}
                              changeMethod={this.toggleIncludeGia.bind(this)} />
                          </div>
                          <div className='includeLabel'>GIA Number</div>
                        </div> :
                        null
                      }
                      <div className='includeItem'>
                        <div className='includeCheckbox'>
                          <RhinoCheckbox
                            selected={this.state.includePrice}
                            changeMethod={this.toggleIncludePrice.bind(this)} />
                        </div>
                        <div className='includeLabel'>Price</div>
                      </div>
                      <div className='includeItem'>
                        <div className='includeCheckbox'>
                          <RhinoCheckbox
                            selected={this.state.includeImage}
                            changeMethod={this.toggleIncludeImage.bind(this)} />
                        </div>
                        <div className='includeLabel'>Image</div>
                      </div>
                      {this.isDiamond() ?
                        <div className='includeItem'>
                          <div className='includeCheckbox'>
                            <RhinoCheckbox
                              selected={this.state.includeVideo}
                              changeMethod={this.toggleIncludeVideo.bind(this)} />
                          </div>
                          <div className='includeLabel'>Video</div>
                        </div> :
                        null
                      }
                    </div>
                  </div> :
                  null
                }
                <div className='shareMessageWrapper'>
                  <div className='shareOptionalMessageWrapper'>
                    <div className='messageInputWrapper'>
                      <textarea className='messageInput' onChange={this.changeMessage.bind(this)} value={this.state.message} placeholder='Add optional message here'></textarea>
                    </div>
                  </div>
                </div>
                <div className='sendMessageWrapper'>
                  <div 
                    className={'actionButton sendButton'} 
                    disabled={!this.state.sendingRequest} 
                    onClick={this.handleSubmit.bind(this)}>
                    Next
                  </div>
                </div>
              </div> :
              null
            }
          </div> :
          <div className='deliveryStep'>
            <div className='shareWrapper'>
              <div className='shareLabel'>Share with:</div>
              <div className='shareIconRow'>

                  <div className='shareIcon' onClick={() => this.showEmailSection()}>
                    <img src='/img/icons/share/email.svg' />
                  </div>

                  {this.isDiamond() ?
                    <a 
                      href={'sms:?&body=' + encodeURIComponent('Check out the diamond collection I have shared! Please reply STOP if you no longer wish to receive messages. ' + base_url + '/my-collection/' + this.state.externalShare.lookup_key)}
                      onClick={this.closeDropdown.bind(this)}>
                      <div className='shareIcon'>
                        <img src='/img/icons/share/text.svg' />
                      </div>
                    </a> :
                    null
                  }

                  {this.isWatch() ?
                    <a 
                      href={'sms:?&body=' + encodeURIComponent('Check out the timepiece collection I have shared! Please reply STOP if you no longer wish to receive messages. ' + base_url + '/my-timepiece-collection/' + this.state.externalShare.lookup_key)}
                      onClick={this.closeDropdown.bind(this)}>
                      <div className='shareIcon'>
                        <img src='/img/icons/share/text.svg' />
                      </div>
                    </a> :
                    null
                  }

              </div>
            </div>
            {this.state.emailSectionOpen ?
              <div className='emailSection'>
                <div className='inputWrapper'>
                  <input 
                    type='email' 
                    placeholder='Enter email address' 
                    value={this.state.email} 
                    onChange={this.changeEmail.bind(this)} />
                </div>
                <div className={'inputWrapper fullWidth'}>
                  <button 
                    type='button' 
                    className={'searchLeadsButton actionButton'}
                    onClick={this.sendShareEmail.bind(this)}>
                    Share
                  </button>
                </div>
                <br />
              </div> :
              null
            }
          </div>
        }
      </div>
    </div>;
	}
}
export default ShareDirect;

function mapStateToProps(state) {
  return {
    leads: state.leads,
  };
}

export const ShareDirectContainer = connect(
  mapStateToProps,
  allActionCreators
)(ShareDirect);